module.exports = __webpack_public_path__ + "media/images/paid-bd15ce58aafbdedaff9d45a015ce7e25.svg";